/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class ContactApi {
    constructor(api) {
        this.api = api;
    }

    async sendMail(form) {
        return await this.api.post(`/contact/sendMail`, form);
    }
    
    async sendMailPublic(form) {
        return await this.api.post(`/contact/sendMailPublic`, form);
    }
}
